//-------------------------- verification  -------------------------- //

window.stepCheck = {}

stepCheck.stepDetails = async function (stepSelected, with_error, with_target, is_step_handle) {
    const stepElement = steps[stepSelected]
    let error = false

    // First Name
    const first_name = stepElement.querySelector('#first_name')

    if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
        error = true

        if (with_target == null || with_target === 'first_name') {
            toggleInputError(first_name, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'first_name') {
            toggleInputError(first_name, stepElement, true, with_error)
        }
    }

    // Last Name
    const last_name = stepElement.querySelector('#last_name')

    if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
        error = true

        if (with_target == null || with_target === 'last_name') {
            toggleInputError(last_name, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'last_name') {
            toggleInputError(last_name, stepElement, true, with_error)
        }
    }

    // Address
    const address = stepElement.querySelector('#address')

    if (address.value.length === 0) {
        error = true

        if (with_target == null || with_target === 'address') {
            toggleInputError(address, stepElement, false, with_error)
        }
    } else {
        if (hasAddressDetails() === false) {
            error = true

            if (with_target == null || with_target === 'address') {
                toggleInputError(address, stepElement, false, with_error)
            }
        } else {
            if (with_target == null || with_target === 'address') {
                toggleInputError(address, stepElement, true, with_error)
            }
        }
    }

    // Phone
    const phone = stepElement.querySelector('#phone')

    if (isNumOnlyPhone(phone.value) === false) {
        error = true

        if (with_target == null || with_target === 'phone') {
            toggleInputError(phone, stepElement, false, with_error)
        }
    } else {
        if (is_step_handle === true) { // Do phone verification only when button is clicked
            toggleLoading(phone, true)

            let is_valid = await twilioVerify(phone.value)

            toggleLoading(phone, false)

            if (is_valid === true) {
                toggleInputError(phone, stepElement, true, with_error)
            } else {
                error = true

                toggleInputError(phone, stepElement, false, with_error)
            }
        } else {
            if (with_target == null || with_target === 'phone') {
                toggleInputError(phone, stepElement, true, with_error)
            }
        }
    }

    // Email
    const email = stepElement.querySelector('#email')

    if (isEmailAddress(email.value) === false) {
        error = true

        if (with_target == null || with_target === 'email') {
            toggleInputError(email, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'email') {
            toggleInputError(email, stepElement, true, with_error)
        }
    }

    // Product interest
    const product_interest = stepElement.querySelectorAll('.product-interest-list input[type="checkbox"]')
    let has_product_interest = false

    product_interest.forEach((interest) => {
        if (interest.checked) {
            has_product_interest = true
        }
    })

    if (has_product_interest === false) {
        error = true

        if (with_target == null || with_target === 'product_interest') {
            product_interest.forEach((checkbox) => {
                checkbox.classList.add('is-invalid')
            })
        }
    } else {
        if (with_target == null || with_target === 'product_interest') {
            product_interest.forEach((checkbox) => {
                checkbox.classList.remove('is-invalid')
            })
        }
    }

    const product_interest_other = stepElement.querySelector('#product_interest_other')
    const product_interest_other_notes = stepElement.querySelector('#product_interest_other_notes')

    if (product_interest_other.checked) {
        if (product_interest_other_notes.value.length === 0) {
            product_interest_other_notes.classList.add('is-invalid')
        } else {
            product_interest_other_notes.classList.remove('is-invalid')
        }
    } else {
        product_interest_other_notes.classList.remove('is-invalid')
    }

    // Referral producer first and last name
    const referral_producer_first = stepElement.querySelector('#referral_producer_first')
    const referral_producer_last = stepElement.querySelector('#referral_producer_last')

    if (referral_producer_first.value.length === 0 || isAlphaString(referral_producer_first.value) === false) {
        error = true

        if (with_target == null || with_target === 'referral_producer_first') {
            toggleInputError(referral_producer_first, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'referral_producer_first') {
            toggleInputError(referral_producer_first, stepElement, true, with_error)
        }
    }

    if (referral_producer_last.value.length === 0 || isAlphaString(referral_producer_last.value) === false) {
        error = true

        if (with_target == null || with_target === 'referral_producer_last') {
            toggleInputError(referral_producer_last, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'referral_producer_last') {
            toggleInputError(referral_producer_last, stepElement, true, with_error)
        }
    }

    // Referral producer number (identifier, not a phone number)
    const referral_producer_phone = stepElement.querySelector('#referral_producer_phone')

    if (referral_producer_phone.value.trim().length === 0) {
        error = true

        if (with_target == null || with_target === 'referral_producer_phone') {
            toggleInputError(referral_producer_phone, stepElement, false, with_error)
        }
    } else {
        if (with_target == null || with_target === 'referral_producer_phone') {
            toggleInputError(referral_producer_phone, stepElement, true, with_error)
        }
    }

    // PC License
    const pc_license = stepElement.querySelectorAll('input[type="radio"][name="pc_license"]')
    let has_pc_license = false

    pc_license.forEach((radio) => {
        if (radio.checked) {
            has_pc_license = true
        }
    })

    if (has_pc_license === false) {
        error = true

        if (with_target == null || with_target === 'pc_license') {
            pc_license.forEach((radio) => {
                radio.classList.add('is-invalid')
            })
        }
    } else {
        if (with_target == null || with_target === 'pc_license') {
            pc_license.forEach((radio) => {
                radio.classList.remove('is-invalid')
            })
        }
    }

    // Compensation Selection
    const compensation_selection = stepElement.querySelectorAll('input[type="radio"][name="compensation_selection"]')
    let has_compensation_selection = false

    compensation_selection.forEach((radio) => {
        if (radio.checked) {
            has_compensation_selection = true
        }
    })

    if (has_compensation_selection === false) {
        error = true

        if (with_target == null || with_target === 'compensation_selection') {
            compensation_selection.forEach((radio) => {
                radio.classList.add('is-invalid')
            })
        }
    } else {
        if (with_target == null || with_target === 'compensation_selection') {
            compensation_selection.forEach((radio) => {
                radio.classList.remove('is-invalid')
            })
        }
    }

    // TCPA info
    const tcpa_info = stepElement.querySelector('#tcpa_info')

    if (tcpa_info.checked) {
        if (with_target == null || with_target === 'tcpa_info') {
            stepElement.querySelector('.tcpa-info').classList.remove('text-danger')
        }
    } else {
        error = true

        if (with_target == null || with_target === 'tcpa_info') {
            stepElement.querySelector('.tcpa-info').classList.add('text-danger')
        }
    }

    toggleFormError(error)

    return error
}

//-------------------------- binds  -------------------------- //

window.setupBind = {}

setupBind.stepDetails = function (stepElement, stepKey) {
    //first_name
    let inputFirstName = stepElement.querySelector('#first_name')

    inputFirstName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'first_name')
    })

    inputFirstName.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'first_name')
    })

    //last_name
    let inputLastName = stepElement.querySelector('#last_name')

    inputLastName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'last_name')
    })

    inputLastName.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'last_name')
    })

    //address
    let inputAddress = stepElement.querySelector('#address')

    inputAddress.addEventListener('keydown', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        resetAddressComponent()

        stepCheck.stepDetails(stepKey, false, 'address')
    })

    inputAddress.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'address')
    })

    //email
    let inputEmail = stepElement.querySelector('#email')

    inputEmail.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'email')
    })

    inputEmail.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'email')
    })

    //phone
    let inputPhone = stepElement.querySelector('#phone')

    inputPhone.addEventListener('keydown', async (event) => {
        if (!upKeyCodePhone(event)) {
            event.preventDefault()
        }
    })

    inputPhone.addEventListener('keyup', async (event) => {
        if (formatKeyCodePhone(event)) {
            formatToNumOnlyPhone(event)

            await stepCheck.stepDetails(stepKey, false, 'phone')
        }
    })

    inputPhone.addEventListener('change', async (event) => {
        formatToNumOnlyPhone(event)

        await stepCheck.stepDetails(stepKey, false, 'phone')
    })

    //product_interest
    const product_interest = stepElement.querySelectorAll('.product-interest-list input[type="checkbox"]')

    product_interest.forEach((interest) => {
        interest.addEventListener('change', () => {
            stepCheck.stepDetails(stepKey, false, 'product_interest')
        })
    })

    const product_interest_other_notes = stepElement.querySelector('#product_interest_other_notes')

    product_interest_other_notes.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'product_interest')
    })

    product_interest_other_notes.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'product_interest')
    })

    //referral_producer
    let inputReferralProducerFirst = stepElement.querySelector('#referral_producer_first')
    let inputReferralProducerLast = stepElement.querySelector('#referral_producer_last')

    inputReferralProducerFirst.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'referral_producer_first')
    })

    inputReferralProducerFirst.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'referral_producer_first')
    })

    inputReferralProducerLast.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'referral_producer_last')
    })

    inputReferralProducerLast.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'referral_producer_last')
    })

    //referral_producer_phone - free-form text field
    let inputReferralProducerPhone = stepElement.querySelector('#referral_producer_phone')

    inputReferralProducerPhone.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepDetails(stepKey, false, 'referral_producer_phone')
    })

    inputReferralProducerPhone.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'referral_producer_phone')
    })

    //pc_license
    const optionsPcLicense = stepElement.querySelectorAll('input[type="radio"][name="pc_license"]')

    optionsPcLicense.forEach(radio => radio.addEventListener('click', async () => {
        stepCheck.stepDetails(stepKey, false, 'pc_license')
    }))

    //compensation_selection
    const optionsCompensationSelection = stepElement.querySelectorAll('input[type="radio"][name="compensation_selection"]')

    optionsCompensationSelection.forEach(radio => radio.addEventListener('click', async () => {
        stepCheck.stepDetails(stepKey, false, 'compensation_selection')
    }))

    //tcpa_info
    let inputTcpaInfo = stepElement.querySelector('#tcpa_info')

    inputTcpaInfo.addEventListener('change', () => {
        stepCheck.stepDetails(stepKey, false, 'tcpa_info')
    });
}

//-------------------------- form  -------------------------- //

submitHandle = function (button) {
    const form = button.form
    const formData = new FormData(form)

    stepNextButtonLoading(button, false) //this actually disable overlay

    if (typeof options.submitCallback !== 'undefined' && typeof options.submitCallback === 'function') {
        options.submitCallback(formData)
    }

    //process
    fetch(options.processURL, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
        }
    })
}
